import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    selectContainer: {
      position: 'absolute',
      zIndex: 400,
      width: '100%',
      padding: '2rem 1rem',
      textAlign: 'left',
    },
    selectWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '90%',
      margin: '0 auto',
    },
    select: {
      background: theme.palette.background.paper,
      color: theme.palette.secondary.main,

      borderRadius: 5,
      fontSize: '1.2rem',
      fontWeight: 600,
      width: '100%',
      minHeight: '4rem',

      '& .MuiSelect-select': {
        padding: '1rem',
        lineHeight: '1.5',
      },

      '& .MuiSelect-icon': {
        color: theme.palette.secondary.main,
      },
    },
    selectOption: {
      fontSize: '1.2rem',
      fontWeight: 600,
      display: 'flex',
      gap: '0.5rem',
      width: '100%',
    },
    separatorOptionData: {
      width: '1px',
      height: '100%',
      backgroundColor: '#DEE5DA',
    },
    menuPaper: {
      maxHeight: '200px',
      overflowY: 'auto',
    },
    menuItem: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '100%',
    },
  }),
)
